// S11-9: one-shot fetch of the Worker's build identity.
//
// Used by AppShell's footer to show "VISTA <version> · Colorado
// Communications" with a tooltip carrying commit SHA + built_at.
//
// Cached for the session (staleTime: Infinity) so the footer stays
// stable without refetching on every navigation — the endpoint is
// public and the response shape doesn't change mid-session.

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useVersionInfo() {
  return useQuery({
    queryKey: ['version'],
    queryFn: () => api.get('/version'),
    staleTime: Infinity,
    retry: 1,
    select: (resp) => {
      // Envelope shape {data: {version, commit, built_at}, cursor, error}.
      // Bare object tolerated as a fallback.
      const d = resp?.data ?? resp ?? {};
      return {
        version: d.version || 'dev',
        commit: d.commit || 'dev',
        builtAt: d.built_at || null,
      };
    },
  });
}
